var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-wrapper-scroll-y"},[_c('b-table',{attrs:{"items":_vm.partials,"fields":_vm.fields},scopedSlots:_vm._u([{key:"workOrderDate",fn:function(data){return [_vm._v(_vm._s(_vm._f("moment")(data.item.workOrderDate,'DD/MM/YYYY')))]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f9b3018","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/projectOthersPartials/ProjectOthersPartialsTable.vue
// module id = null
// module chunks = 